export default "__VITE_ASSET__DqtQcpKT__"